import {getUrl} from "../../../constants/urls";

export const webhookListUrl = getUrl("listWebHooks");

export const LIST_HEADERS = ["delivery_id", "timestamp", "status", "message"];

export const CUSTOM_RENDER_KEYS = ["status"];
